import styled, { createGlobalStyle } from 'styled-components';
import { Button, Input, Modal, Select } from 'antd';
import { COLORS } from '@/app/constants';

export const CustomModal = styled(Modal)`
  width: 636px !important;

  .ant-modal-close {
    width: 16px;
    height: 16px;
    top: 24px;
    right: 24px;
    color: #fff;
  }

  .ant-modal-content {
    padding: 20px 16px;
    background-color: #242526;
  }
`;

// 전체 컨테이너 - 세로 레이아웃
export const CalculatorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0;
`;

// 상단 고정 영역 (드롭다운 + 탭)
export const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

// 하단 컨텐츠 영역 (좌우 분할)
export const ContentSection = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`;

// 왼쪽 입력 영역
export const LeftSection = styled.div`
  width: 354px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

// 오른쪽 결과 영역
export const RightSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

// 드롭다운 스타일
export const CoinSelect = styled(Select)`
  position: relative;
  width: 252px;
  height: 34px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);

  .ant-select-selector {
    padding: 0 12px !important;
    background: transparent !important;
  }

  .ant-select-arrow {
    color: #ffffff;
  }
`;

// 탭 섹션
export const TabSection = styled.div`
  display: flex;
  gap: 16px;
  border-bottom: 1px solid #353535;
  padding-bottom: 0;
`;

// 탭 버튼 (밑줄 스타일)
export const TabButton = styled.button<{ $active: boolean }>`
  padding: 8px 0;
  border: none;
  background: transparent;
  color: ${({ $active }) => ($active ? '#ffffff' : '#777986')};
  font-family: 'NanumSquareRound', sans-serif;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: -0.28px;
  cursor: pointer;
  position: relative;
  transition: color 0.2s;

  &::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    right: 0;
    height: 2px;
    background-color: ${({ $active }) => ($active ? '#07d993' : 'transparent')};
    transition: background-color 0.2s;
  }

  &:hover {
    color: #ffffff;
  }
`;

// Long/Short 버튼 컨테이너
export const DirectionSection = styled.div`
  display: flex;
  gap: 8px;
`;

// Long/Short 버튼
export const DirectionButton = styled.button<{
  $active: boolean;
  $type: 'long' | 'short';
}>`
  flex: 1;
  height: 32px;
  border-radius: 6px;
  border: none;
  font-family: 'NanumSquareRound', sans-serif;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: -0.42px;
  cursor: pointer;
  transition: all 0.2s;

  ${({ $active, $type }) => {
    if ($active) {
      return `
        background-color:${$type === 'long' ? COLORS.lightGreen : COLORS.lightRed};
        color: #0d1117;
      `;
    } else {
      return `
        background: #2A2C2E;
        color: #777986;
      `;
    }
  }}

  &:hover {
    ${({ $active }) =>
      !$active &&
      `
      border-color: #07d993;
      color: #ffffff;
    `}
  }
`;

// 레버리지 섹션
export const LeverageSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const LeverageLabel = styled.span`
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 12px;
  letter-spacing: -0.36px;
  color: #b3b5bd;
`;

export const LeverageValueBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #2a2c2e;
  border-radius: 6px;
  height: 40px;
  padding: 0 16px;

  span {
    font-family: 'NanumSquareRound', sans-serif;
    font-weight: 700;
    font-size: 16px;
    letter-spacing: -0.32px;
    color: #ffffff;
  }
`;

export const SliderSection = styled.div`
  width: 100%;
  padding: 4px 12px;

  .ant-slider {
    margin: 8px 0 24px 0;
  }

  .ant-slider-mark-text {
    font-family: 'NanumSquareRound', sans-serif;
    font-size: 11px;
    letter-spacing: -0.22px;
    color: #777986;

    top: 6px;
  }
`;

// 입력 섹션
export const InputSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

// 입력 그룹 (라벨 + 입력필드)
export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const InputLabel = styled.span`
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 12px;
  letter-spacing: -0.36px;
  color: #b3b5bd;
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #2a2c2e;
  border: 1px solid transparent;
  border-radius: 6px;
  height: 40px;
  padding: 0 12px;

  input {
    flex: 1;
    background: transparent;
    border: none;
    outline: none;
    color: #ffffff;
    font-family: 'NanumSquareRound', sans-serif;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: -0.28px;

    &::placeholder {
      color: #777986;
    }

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }

  &:hover {
    background-color: #2a2c2e;
    border: 1px solid rgba(255, 255, 255, 0.12);
  }

  &: focus {
    background-color: #2a2c2e;
    border: 1px solid rgba(255, 255, 255, 0.12);
  }
`;

export const InputSuffix = styled.span`
  font-family: 'NanumSquareRound', sans-serif;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: -0.24px;
  color: #b3b5bd;
`;

// 결과 카드
export const ResultCard = styled.div`
  background-color: #1a1c1b;
  border-radius: 8px;
  padding: 20px 16px;
  height: 100%;
`;

export const ResultTitle = styled.div`
  font-family: 'NanumSquareRound', sans-serif;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: -0.28px;
  color: #ffffff;
  margin-bottom: 16px;
`;

export const ResultRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;

  &:not(:last-child) {
    border-bottom: 1px solid #2a2c2e;
  }
`;

export const ResultLabel = styled.span`
  font-family: 'NanumSquareRound', sans-serif;
  font-size: 12px;
  letter-spacing: -0.36px;
  color: #b3b5bd;
`;

export const ResultValue = styled.span<{ $color?: string }>`
  font-family: 'NanumSquareRound', sans-serif;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: -0.24px;
  color: ${({ $color }) => $color || '#ffffff'};
  text-align: right;
`;

// 구분선 (사용하지 않을 수 있음)
export const SectionDivider = styled.div`
  width: 100%;
  height: 1px;
  background: #353535;
  margin: 4px 0;
`;

// 기존 호환용 (제거 예정)
export const StyledInput = styled(Input)<{ $isDarkMode?: boolean }>`
  flex: 1;
  border: none !important;
  background: transparent !important;
  padding: 4px 8px !important;
  font-size: 14px !important;
  box-shadow: none !important;

  &:focus {
    box-shadow: none !important;
  }
`;

export const ClearButton = styled(Button)<{ $isDarkMode?: boolean }>`
  display: none;
`;

export const InputRow = styled.div<{ $isDarkMode?: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const CalculateButton = styled(Button)`
  display: none;
`;

// Select Dropdown Global Style (Portal로 body에 렌더링되므로 Global Style 필요)
export const SelectDropdownGlobalStyle = createGlobalStyle`
  .custom-select-dropdown {
    background: linear-gradient(rgba(0, 110, 73, 0.10), rgba(0, 110, 73, 0.10)), #1a1c1b !important;
    border-radius: 12px !important;
    border: 1px solid rgba(255, 255, 255, 0.20) !important;
    padding: 4px !important;

    .ant-select-item {
      color: #ffffff;
      border-radius: 8px;
      padding: 8px 12px;

      &:hover {
        background: rgba(255, 255, 255, 0.05) !important;
      }
    }

    .ant-select-item-option-active {
      background: rgba(255, 255, 255, 0.05) !important;
    }

    .ant-select-item-option-selected {
      background-color: rgba(0, 110, 73, 0.20) !important;

      &:hover {
        background-color: rgba(7, 217, 147, 0.25) !important;
      }
    }
  }
`;
